export const FETCH = "FETCH";
export const FETCH_FAILURE = "FETCH_FAILURE";
export const FETCH_SUCCESS = "FETCH_SUCCESS";

export const RECOVER_IDENTIFIER = "RECOVER_IDENTIFIER";
export const RECOVER_IDENTIFIER_FAILURE = "RECOVER_IDENTIFIER_FAILURE";
export const RECOVER_IDENTIFIER_SUCCESS = "RECOVER_IDENTIFIER_SUCCESS";



// WEBPACK FOOTER //
// ./src/components/member-identifier-recovery/memberIdentifierRecoveryActionTypes.js